import * as z from "zod/v4";

export const bulkRemoveTopicsFromPrompts = {
  name: "bulkRemoveTopicsFromPrompts" as const,
  input: z.object({
    promptIds: z.array(z.bigint()),
    topicIds: z.array(z.bigint()),
  }),
  output: z.object({}),
};
